import type { AutoCompleteProps, CheckboxProps, GetProp, TabsProps } from 'antd';
import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import CollapsedIcon from './images/collapsed-icon.svg?react';
import MuteIcon from './images/mute-icon.svg?react';
import CloseVideoIcon from './images/close-video-icon.svg?react';
import UnMuteIcon from './images/unmute-icon.svg?react';
import MoreIcon from './images/more-icon.svg?react';
import CloseIcon from './images/close-icon.svg?react';
import styles from './index.module.scss';

interface AddMembersModalProps {
  open: boolean;
  normalMemberList?: ChatGroupMember[];
  onCancel: () => void;
}

const ParticipantsModal = ({ open, onCancel }: AddMembersModalProps) => {
  const [selectSuggestionsUsers, setSelectSuggestionsUsers] = useState<any[]>([]);
  const [options, setOptions] = useState<AutoCompleteProps['options']>([]);
  const [activeKey, setActiveKey] = useState<string>('All');

  const callingUsers = [
    {
      id: '1',
      name: 'user1',
    },
    {
      id: '2',
      name: 'user2',
    },
  ];
  const inMeetingUsers = [
    {
      id: '3',
      name: 'user3',
    },
    {
      id: '4',
      name: 'user4',
    },
  ];
  const suggestionsUsers = [
    {
      id: '5',
      name: 'user5',
    },
    {
      id: '6',
      name: 'user6',
    },
  ];

  const handleSearch = useCallback((value: string) => {
    setOptions(() => {
      if (!value) {
        return [];
      }
      const resData = [
        {
          id: '5',
          name: 'user5',
        },
        {
          id: '6',
          name: 'user6',
        },
      ];
      return resData
        .filter((item) => item.name.includes(value))
        .map((item) => ({
          value: item.id,
          label: (
            <Flex key={item.id} justify="space-between" style={{ padding: '5px 0 0' }}>
              <Flex align="center" gap={10}>
                <Avatar size={28} icon={<UserOutlined />} />
                <span>{item.name}</span>
              </Flex>
              <Button onClick={() => onCallClick(item)}>Call</Button>
            </Flex>
          ),
        }));
    });
  }, []);

  const cancelAllClick = () => {
    console.log('cancelAllClick');
  };
  const onCallClick = (user: any) => {
    console.log(user);
  };
  const onCallCancel = (user: any) => {
    console.log(user);
  };
  const onMuteClick = (user: any) => {
    console.log(user);
  };
  const muteAllClick = () => {
    console.log('muteAllClick');
  };
  const unMuteAllClick = () => {
    console.log('unMuteAllClick');
  };
  const callAllClick = () => {
    console.log('callAllClick', selectSuggestionsUsers);
  };

  const onSuggestionsUsersChange: GetProp<typeof Checkbox.Group, 'onChange'> = (
    checkedValues
  ) => {
    setSelectSuggestionsUsers(checkedValues);
  };

  const onCheckAllChange: CheckboxProps['onChange'] = (e) => {
    setSelectSuggestionsUsers(
      e.target.checked ? suggestionsUsers.map((item) => item.id) : []
    );
  };

  useEffect(() => {
    if (open) {
      setActiveKey('All');
    }
  }, [open]);

  const items: TabsProps['items'] = [
    {
      key: 'All',
      label: `All (${3})`,
      children: (
        <Flex vertical gap={16}>
          <Card styles={{ body: { padding: 10, maxHeight: 300, overflow: 'auto' } }}>
            <Flex justify="space-between">
              <Flex align="center" gap={4}>
                <CollapsedIcon />
                <span>Calling (1)</span>
              </Flex>
              <a onClick={cancelAllClick}>Cancel All</a>
            </Flex>
            {callingUsers.map((user, index) => (
              <Flex
                key={index}
                justify="space-between"
                style={{ padding: '18px 6px 0' }}
              >
                <Flex align="center" gap={10}>
                  <Avatar size={28} icon={<UserOutlined />} />
                  <span>{user.name}</span>
                </Flex>
                <Button onClick={() => onCallCancel(user)}>Cancel</Button>
              </Flex>
            ))}
            <Flex justify="space-between" style={{ paddingTop: 18 }}>
              <Flex align="center" gap={4}>
                <CollapsedIcon />
                <span>In the meeting (2)</span>
              </Flex>
            </Flex>
            {inMeetingUsers.map((user) => (
              <Flex key={user.id} justify="space-between" className={styles.operateBar}>
                <Flex align="center" gap={10}>
                  <Avatar size={28} icon={<UserOutlined />} />
                  <span>{user.name}</span>
                </Flex>
                <Flex align="center" gap={16}>
                  {/* TODO: isMute status */}
                  <MuteIcon className={cls(styles.pointer, styles.statusIcon)} />
                  <CloseVideoIcon className={cls(styles.pointer, styles.statusIcon)} />
                  <UnMuteIcon
                    className={cls(styles.pointer, styles.operateIcon)}
                    onClick={() => onMuteClick(user)}
                  />
                  <Dropdown
                    placement="bottomRight"
                    menu={{
                      items: [
                        {
                          key: '1',
                          label: 'Ask to unmute',
                        },
                        {
                          key: '2',
                          label: 'Ask to start video',
                        },
                        {
                          key: '3',
                          label: 'Make host',
                        },
                        {
                          key: '4',
                          label: 'Remove from meeting',
                          danger: true,
                        },
                      ],
                    }}
                  >
                    <MoreIcon className={cls(styles.pointer, styles.operateIcon)} />
                  </Dropdown>
                </Flex>
              </Flex>
            ))}
          </Card>
          <Flex gap={16} justify="flex-end">
            <Button onClick={muteAllClick}>Mute All</Button>
            <Button onClick={unMuteAllClick}>Ask all to unmute</Button>
          </Flex>
        </Flex>
      ),
    },
    {
      key: 'Suggestions',
      label: `Suggestions (${1})`,
      children: (
        <Flex vertical gap={16}>
          <Checkbox.Group
            value={selectSuggestionsUsers}
            onChange={onSuggestionsUsersChange}
          >
            <Card
              styles={{ body: { padding: 10, maxHeight: 300, overflow: 'auto' } }}
              style={{ width: '100%' }}
            >
              {suggestionsUsers?.map((user) => (
                <Flex
                  key={user.id}
                  justify="space-between"
                  style={{ padding: '9px 6px' }}
                >
                  <Checkbox className={styles.checkbox} value={user.id}>
                    <Flex align="center" gap={10}>
                      <Avatar size={28} icon={<UserOutlined />} />
                      <span>{user.name}</span>
                    </Flex>
                  </Checkbox>
                  <Button onClick={() => onCallClick(user)}>Call</Button>
                </Flex>
              ))}
            </Card>
          </Checkbox.Group>
          <Flex gap={16} justify="space-between" align="center">
            <Checkbox
              className={styles.checkbox}
              onChange={onCheckAllChange}
              checked={selectSuggestionsUsers?.length === suggestionsUsers?.length}
            >
              Select all
            </Checkbox>
            <Button
              onClick={callAllClick}
              disabled={selectSuggestionsUsers?.length == 0}
            >
              Call
            </Button>
          </Flex>
        </Flex>
      ),
    },
  ];

  return (
    <Modal
      zIndex={2001}
      width={440}
      title={
        <Flex justify="space-between" style={{ paddingBottom: 12 }}>
          <span>Participants</span>
          <Flex gap={16}>
            <CloseIcon className={styles.pointer} onClick={onCancel} />
          </Flex>
        </Flex>
      }
      open={open}
      onCancel={onCancel}
      maskClosable={false}
      footer={null}
      closeIcon={null}
      className={styles.participantsModal}
    >
      <Flex vertical gap={10}>
        <AutoComplete
          prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
          variant="filled"
          placeholder="Search"
          onSearch={handleSearch}
          options={options}
        />
        <Tabs
          activeKey={activeKey}
          onChange={(key) => setActiveKey(key)}
          items={items}
        />
      </Flex>
    </Modal>
  );
};

export default ParticipantsModal;
